module.exports = __webpack_public_path__ + "img/coupon-icon-6.a1ed8b05.png";